import React from 'react'
import '../styles/workpages.css';
import AltNav from '../components/AltNav.js';

const AlphaBuilders = () => {
    return (
        <div>
            <AltNav />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />

            <div className='work-page-main'>
                <div className='blue-glow projects-header'>
                    <div className='gb-inner gb-inner-img' style={{ backgroundImage: `url('portfolio-images/ab.jpg')` }}>
                        <div class="glow-wrapper">
                            <span class="glow-text">ALPHA BUILDERS</span>
                            <span class="stroke-text">ALPHA BUILDERS</span>
                        </div>

                    </div>
                </div>


                <br />
                <br />

                <div className='overview'>
                    <div className='ov1'>
                        <h2>Overview</h2>

                        <p>A Company Website for Alpha Builders built with React and optimized for SEO</p>

                        <ul>
                            <li>Built with React and Node</li>
                            <li>Modern dark mode design with brass and burnt orange accents</li>
                            <li>Hosted on Vercel and App Engine</li>
                            <li>Uses Google Cloud Platform for posting images and managing secrets and auth</li>
                            <li>API routes are protected with auth headers</li>
                            <li>SEO is optimized with React Helmet, allowing different pages to have different Meta tags</li>
                        </ul>
                        <a href='https://alphabuilders-wa.com/' target='_blank'>
                            <button className='glow-box-btn ovbtn'>
                                Visit Site
                            </button>
                        </a>

                    </div>
                    <div className='ov2'>
                        <div className='pink-glow'>
                            <div className='pg-inner'>
                                <img src='portfolio-images/ab-1.jpg' alt='alpha builders projects page' />
                            </div>

                        </div>

                    </div>
                </div>
                <br />
                <br />

                <div className='blue-glow-alt'>
                    <div className='gb-inner-alt'>
                        <video className='video' muted autoPlay loop playsInline>
                            <source src="images/abv.mp4" type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                    </div>
                </div>


                <br />
                <br />


                <div className='pink-glow'>
                    <div className='pg-inner project-summary'>
                        <h3 className='summary'>Summary</h3>
                        <p>I created a company website for Alpha Builders a general contracting service in Enumclaw Washington. Aside from putting a lot of time and effort into the design and UI of this site, I also created a cms system that allows Alpha Builders to post new projects and new reviews from customers. I built the site with React using Create React App then added a node server and used express to create the api. Since projects have images, I used multer for the image file uploads on the frontend and then had them be sent and retrieved to a google cloud storage bucket. The site uses protected routes and advanced secuirty to protect CMS access. It also uses a mongodb serverless database. The frontend is hosted on Vercel and the backend is hosted on google app engine.</p>
                    </div>
                </div>

                <br />
                <br />







            </div>


        </div>
    )
}

export default AlphaBuilders